// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-breadcrumb[data-v-c80c4972]{height:100%;line-height:3rem;position:relative}.menu-breadcrumb a[data-v-c80c4972]:active,.menu-breadcrumb a[data-v-c80c4972]:hover{-webkit-text-decoration:none;text-decoration:none}.menu-breadcrumb .breadcrumb-arrow[data-v-c80c4972]{font-size:1rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
